<app-loading-spinner *ngIf="isLoading" />

<div *ngIf="!isLoading">
    <div class="flex gap-0 cursor-pointer">
        <p class="font-semibold text[#424242] mb-4 mr-5 ml-0 dark:text-[#FFFFFF] dark:bg-blacks">Centres</p>
    </div>

    <div class="w-full min-w-0 px-4 sm:px-6 lg:px-10 py-7 bg-tileLight dark:bg-[#363636] shadow-lg rounded-lg">
        <div class="flex flex-wrap items-center justify-between gap-4 w-full min-w-0">
            <div class="flex flex-col justify-between min-w-0">
                <p class="font-semibold md:text-lg lg:text-lg mb-1 dark:text-white">Total Centres
                    ({{totalItems | number:'2.0-0'}})</p>
            </div>
            <div class="grid flex-[1_1_34rem] grid-cols-[auto_minmax(0,1fr)_minmax(0,1fr)_minmax(0,2fr)] items-center justify-end gap-3 min-w-0 [@container(max-width:760px)]:basis-full [@container(max-width:760px)]:grid-cols-2 [@container(max-width:760px)]:[&>:first-child]:col-span-full [@container(max-width:480px)]:grid-cols-1">
                <div class="flex items-center gap-3">
                    <i class="fa-solid fa-list text-lg text-[#4A4A4A] dark:text-white flex-shrink-0"></i>
                    <p class="text-[#4A4A4A] dark:text-white whitespace-nowrap">Filter By</p>
                </div>

                <div class="contents">
                    <!-- Province Dropdown -->
                    <div class="min-w-0">
                        <app-searchable-dropdown [items]="provinceItems" [placeholder]="'Province'"
                            [searchPlaceholder]="'Search...'" [clearable]="true" [showSelected]="true"
                            [(ngModel)]="selectProvince" (selectionChange)="onProvinceChange($event)">
                        </app-searchable-dropdown>
                    </div>

                    <!-- District Dropdown -->
                    <div class="min-w-0">
                        <app-searchable-dropdown [items]="districtItems" [placeholder]="'District'"
                            [searchPlaceholder]="'Search...'" [clearable]="true" [showSelected]="true"
                            [(ngModel)]="selectDistrict" (selectionChange)="onDistrictChange($event)">
                        </app-searchable-dropdown>
                    </div>
                </div>

                <div
                    class="w-full [@container(max-width:760px)]:col-span-full [&_button]:shrink-0 flex items-center rounded-full px-4 py-2 min-w-0 bg-[#F1F1F1] dark:bg-[#292929]">
                    <input type="text" placeholder="Search by Reg Code / Centre Name.." [(ngModel)]="searchText"
                        class="bg-transparent outline-none w-full min-w-0 text-textLight dark:text-textDark"
                        (keydown.enter)="onSearch()" (keydown.esc)="offSearch()" />
                    <button type="button" class="text-gray-500 hover:text-gray-700 focus:outline-none mr-2"
                        (click)="onSearch()">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
                            stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M21 21l-6-6m2-5a7 7 0 10-14 0 7 7 0 0014 0z" />
                        </svg>
                    </button>
                    <button type="button" class="text-gray-500 hover:text-gray-700 focus:outline-none"
                        (click)="offSearch()">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
                            stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                </div>
            </div>
        </div>

        <div class="flex flex-row mt-3 mb-0">
            <button class="bg-[#415CFF] text-white font-semibold px-4 py-2 rounded-lg shadow-xl"
                (click)="addCenter()">Add a
                Centre</button>
        </div>


        <div *ngIf="hasData" class="mt-5 min-w-0 max-w-full">
            <div class="overflow-auto max-h-[max(340px,calc(100vh-400px))] border-gray-100 border-[2px] dark:border-[#202021] rounded-lg">
                <table class="w-full min-w-max divide-y-2">
                    <thead
                        class="sticky top-0 z-20 bg-white text-gray-700 dark:text-gray-300 dark:bg-[#0F0F0F] dark:border-[#202021] cursor-default">
                        <tr>
                            <th class="[@container(max-width:640px)]:static sticky left-0 bg-white dark:bg-[#0F0F0F] px-6 py-3 text-left font-normal w-20 min-w-20">No</th>
                            <th class="[@container(max-width:640px)]:static sticky left-20 bg-white dark:bg-[#0F0F0F] px-6 py-3 text-left font-normal w-40 min-w-40 whitespace-nowrap">Reg Code</th>
                            <th class="[@container(max-width:640px)]:static sticky left-60 bg-white dark:bg-[#0F0F0F] px-6 py-3 text-left font-normal w-56 min-w-56 whitespace-nowrap">Centre Name</th>
                            <th class="px-6 py-3 text-left font-normal w-28 whitespace-nowrap">Province</th>
                            <th class="px-6 py-3 text-left font-normal w-28 whitespace-nowrap">District</th>
                            <th class="px-6 py-3 text-left font-normal w-28">City</th>
                            <th class="px-6 py-3 text-left font-normal w-40 whitespace-nowrap">Contact Number -1</th>
                            <th class="px-6 py-3 text-center font-normal w-32 whitespace-nowrap">CCM Profiles</th>
                            <th class="px-6 py-3 text-center font-normal w-32 whitespace-nowrap">COO Profiles</th>
                        </tr>
                    </thead>
                    <tbody *ngIf="countOfOfficers != 0" class="bg-white dark:bg-[#1D1D1F] dark:border-[#1D1D1F]">
                        <tr class="group hover:bg-[#415CFF] hover:text-white dark:text-gray-300 cursor-pointer"
                            *ngFor="let item of itemsArr | paginate : { itemsPerPage: itemsPerPage, currentPage: currentPage, totalItems: totalItems }; let i = index"
                            (click)="navigateToDashboard(item.centerId)">
                            <td class="[@container(max-width:640px)]:static sticky left-0 z-10 bg-white dark:bg-[#1D1D1F] group-hover:bg-[#415CFF] px-6 py-3 font-medium text-center">
                                {{ ('0' + ((currentPage - 1) * itemsPerPage + i + 1)).slice(-2) }}
                            </td>
                            <td class="[@container(max-width:640px)]:static sticky left-20 z-10 bg-white dark:bg-[#1D1D1F] group-hover:bg-[#415CFF] px-6 py-3 font-medium text-left break-all">{{ item.regCode }}</td>
                            <td class="[@container(max-width:640px)]:static sticky left-60 z-10 bg-white dark:bg-[#1D1D1F] group-hover:bg-[#415CFF] px-6 py-3 font-medium text-left">{{ item.centerName }}</td>
                            <td class="px-6 py-3 font-medium text-left">{{ item.province }}</td>
                            <td class="px-6 py-3 font-medium text-left whitespace-nowrap">{{ item.district }}</td>
                            <td class="px-6 py-3 font-medium text-left whitespace-nowrap">{{ item.city }}</td>
                            <td class="px-6 py-3 font-medium text-left whitespace-nowrap">
                                <ng-container *ngIf="item.contact01; else noContact">
                                    {{ '+94' + item.contact01 }}
                                </ng-container>
                                <ng-template #noContact>
                                    N/A
                                </ng-template>
                            </td>
                            <td class="px-6 py-3 font-medium text-center">{{ item.collectionCenterManagerCount }}</td>
                            <td class="px-6 py-3 font-medium text-center">{{ item.collectionOfficerCount }}</td>
                        </tr>
                    </tbody>
                </table>


            </div>

            <div *ngIf="hasData" class="flex justify-end items-center my-5 pt-3 dark:bg-[#1D1D1F] text-right">
                <pagination-controls (pageChange)="onPageChange($event)" [responsive]="true"
                    [previousLabel]="'Previous'" [nextLabel]="'Next'" [screenReaderPaginationLabel]="'Pagination'"
                    [screenReaderPageLabel]="'page'" [screenReaderCurrentLabel]="'Youre on page'">
                </pagination-controls>
            </div>
        </div>



        <div *ngIf="!hasData"
            class="flex flex-col items-center w-full h-screen px-10 py-7 bg-tileLight dark:bg-[#363636] dark:text-textDark mt-6">
            <p class="text-[#494949] my-6 dark:text-textDark">--No Data Availabale--</p>
            <img src="assets/images/NoData.png" alt="No Data" class="w-20 h-20 dark:text-textDark" />
        </div>
    </div>
